<div class="mt-modal blur" [ngClass]="variant">
  <div class="modal-container center">
    <div class="modal-content">
      <div class="modal-body no-scroll">
        <ng-content></ng-content>
      </div>
      <div class="alert-footer">
        @for (btn of buttons; track btn) {
          <mt-btn
            [class]="btn.class"
            [id]="btn.label"
            (onAction)="onClickAction(btn.submit)"
            [disabled]="disabled || btn.disabled"
            >{{ btn.label }}
          </mt-btn>
        }
      </div>
    </div>
  </div>
</div>
